import React from "react";
import Provider from "../provider"
import useFormattedPrice from "@/hooks/shopify-hooks/useFormattedPrice";
import useSalePrice from "@/hooks/shopify-hooks/useSalePrice";

function PriceCmp(props = {}) {
	const { priceChange, variant } = props;
	const { price, compareAtPrice } = variant;
	const _price = useFormattedPrice({
		price,
		currencyCode: price.currencyCode
	});
	let discount = 0;
	let salePrice = null;
	const initPrice={
        amount: '0',
		currencyCode: price.currencyCode,
    };

	salePrice = useFormattedPrice({
		price: compareAtPrice || initPrice,
		currencyCode: initPrice.currencyCode
	});
	discount = useSalePrice(price, compareAtPrice || initPrice);

	if(!compareAtPrice || compareAtPrice.amount === '0' || compareAtPrice.amount === '0.00'){
		salePrice=null;
		discount=null
	}
	priceChange({
		salePrice,
		price: _price,
		discount
	});

	return (<></>)
}

export function reactPriceCmp(props) {
	return (<Provider><PriceCmp {...props}/></Provider>);
}

export default reactPriceCmp;
